import {
  Component, EventEmitter, forwardRef, Input, Output
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType} from "./nbinput.entity";

@Component({
  selector: 'nbinput-inline',
  template: require('./nbinput-inline.component.html'),
  styles: [require('./nbinput-inline.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputInlineComponent),
      multi: true
    }
  ]
})

export class NbinputInlineComponent implements ControlValueAccessor {
  public FieldType = NbFieldType;
  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};
  registerOnChange(fn: any): void {if(fn)this.onChangeCallback = fn;}
  registerOnTouched(fn: any): void {if(fn)this.onTouchedCallback = fn;}
  setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled}
  writeValue(v: string): void {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }

  private preData:string;
  public editing:boolean = false;

  public disabled = false;
  @Input()
  public readonly = false;
  onBlur() { this.onTouchedCallback(); }

  public _data:string;
  @Input()
  set data(val:string){
    this._data = val;
  }
  get data(){
    return this._data;
  }
  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }

  @Input()
  type:NbFieldType = NbFieldType.Text;
  @Input()
  placeholder:string = '点击输入';

  @Output() public onSubmit: EventEmitter<any> = new EventEmitter();
  onSave(){
    this.onSubmit.emit(this.data);
    this.onChangeCallback(this.data);
    this.editing = false;
  }
  onCancel(){
    this._data = this.preData;
    this.editing = false;
  }
  onEdit(){
    this.preData = this._data;  // Store original value in case the form is cancelled
    this.editing = true;
  }

  constructor(){}
}

